/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { AnswerValue } from '../models/answer-value';
import { DocumentRequirementFulfilmentType } from '../models/document-requirement-fulfilment-type';
import { DocumentWorkflow } from '../models/document-workflow';
import { LocalisedString } from '../models/localised-string';
import { PartyStub } from '../models/party-stub';
import { ReferenceDataLevel } from '../models/reference-data-level';
import { StatusType } from '../models/status-type';
import { SystemEntity } from '../models/system-entity';

/**
 * Document Requirement Type DTO
 */
export interface DocumentRequirementType {
  category?: AnswerValue;

  /**
   * An internal human-readable code for the document requirement type
   */
  code?: string | null;
  createdBy?: PartyStub;

  /**
   * The date and time when the document requirement type was created
   */
  createdOn?: string | null;

  /**
   * Description of the document requirement type
   */
  description?: string | null;

  /**
   * An array of document type codes that this document requirement type can be fulfilled with
   */
  documentTypeCodes?: Array<string> | null;
  fulfilmentType?: DocumentRequirementFulfilmentType;
  id?: string | null;

  /**
   * Is the document requirement type active?
   */
  isActive?: boolean;
  level?: ReferenceDataLevel;
  localisedName?: LocalisedString;

  /**
   * A public facing name for the document requirement type
   */
  name?: string | null;

  /**
   * The number of documents required for this document requirement type
   */
  numberRequired?: number | null;

  /**
   * Order to display document requirement types in
   */
  order?: number;
  status?: StatusType;
  targetEntityType?: SystemEntity;
  updatedBy?: PartyStub;

  /**
   * The date and time when the document requirement type was last updated
   */
  updatedOn?: string | null;

  /**
   * The version of the document requirement type
   */
  version?: number;
  workflow?: DocumentWorkflow;
}

export class DocumentRequirementType {
  category?: AnswerValue;
  code?: string | null;
  createdBy?: PartyStub;
  createdOn?: string | null;
  description?: string | null;
  documentTypeCodes?: string[] | null;
  fulfilmentType?: DocumentRequirementFulfilmentType;
  id?: string | null;
  isActive?: boolean;
  level?: ReferenceDataLevel;
  localisedName?: LocalisedString;
  name?: string | null;
  numberRequired?: number | null;
  order?: number;
  status?: StatusType;
  targetEntityType?: SystemEntity;
  updatedBy?: PartyStub;
  updatedOn?: string | null;
  version?: number;
  workflow?: DocumentWorkflow;

  constructor(value: DocumentRequirementType) {
    this.category = value?.category ? new AnswerValue(value.category) : undefined;
    this.code = value?.code;
    this.createdBy = value?.createdBy ? new PartyStub(value.createdBy) : undefined;
    this.createdOn = value?.createdOn;
    this.description = value?.description;
    this.documentTypeCodes = value?.documentTypeCodes;
    this.fulfilmentType = value?.fulfilmentType ? Object.entries(Object.values(DocumentRequirementFulfilmentType)).flatMap((x) => x).find(x => x === value.fulfilmentType) as DocumentRequirementFulfilmentType : undefined;
    this.id = value?.id;
    this.isActive = value?.isActive;
    this.level = value?.level ? Object.entries(Object.values(ReferenceDataLevel)).flatMap((x) => x).find(x => x === value.level) as ReferenceDataLevel : undefined;
    this.localisedName = value?.localisedName ? new LocalisedString(value.localisedName) : undefined;
    this.name = value?.name;
    this.numberRequired = value?.numberRequired;
    this.order = value?.order;
    this.status = value?.status ? Object.entries(Object.values(StatusType)).flatMap((x) => x).find(x => x === value.status) as StatusType : undefined;
    this.targetEntityType = value?.targetEntityType ? Object.entries(Object.values(SystemEntity)).flatMap((x) => x).find(x => x === value.targetEntityType) as SystemEntity : undefined;
    this.updatedBy = value?.updatedBy ? new PartyStub(value.updatedBy) : undefined;
    this.updatedOn = value?.updatedOn;
    this.version = value?.version;
    this.workflow = value?.workflow ? new DocumentWorkflow(value.workflow) : undefined;
  }
}
